<footer>

  <section class="college-footer">
    <div class="general-structure">

      <section class="logo">
        <img src="../../../../assets/img/logo_blanco.svg" class="logo" loading="lazy">
        <p class="copyright">Copyright 2019 © COSITALNETWORK - Todos los derechos reservados</p>
      </section>

      <section>
        <div class="info">
          <div class="title">Secretarios, Interventores y Tesoreros de Administración Local</div>
          <address>
            C/ Carretas 14 - 28012 Madrid<br />
            Teléfono: 915 211 825 - <a href="mailto:cositalnetwork@cosital.es">cositalnetwork&#64;cosital.es</a>
          </address>
        </div>

        <div class="social">
          <a href="https://twitter.com/Cositalnetwork" title="X" target="_blank">
            <span class="icon-x"></span>
          </a>
          <a href="https://www.facebook.com/pages/Cositalnetwork/371811616242353?ref=stream" title="facebook"
            target="_blank">
            <span class="icon-facebook"></span>
          </a>
          <a href="https://t.me/joinchat/AAAAAFZDu7pxB2Zxtq3B9w" title="telegram" target="_blank">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
              stroke-linecap="round" stroke-linejoin="round">
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M15 10l-4 4l6 6l4 -16l-18 7l4 2l2 6l3 -4" />
            </svg>
          </a>
        </div>
      </section>

    </div>
  </section>

  <section class="vf-footer">
    <div class="general-structure">
      <div>
        {{'core.developedBy' | translate}} <a href="http://www.viafisio.com/" target="_blank"
          title="Viafisio">Viafisio</a>
      </div>
      <div class="legal">
        <button class="footer-button" (click)="openDataProtection()">{{'core.dataProtection' | translate}}</button>
        <a href="cookies" class="footer-button">{{'core.cookiesPolicy' | translate}}</a>
        <button class="footer-button" (click)="openLegalWarning()">{{'core.legalWarning' | translate}}</button>
        <button class="footer-button" (click)="openLegalAI()">{{'core.legalAI' | translate}}</button>
      </div>
    </div>
  </section>

</footer>